import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/system/profession_list',
    ADD: '/system/profession_add',
    UPDATE: '/system/profession_update',
	DEL: '/system/profession_del',
	TOP_LIST: '/system/profession_top_list',
    IS_EXIST_WORK_NAME: '/system/profession_is_exist_work_name',
	
	SECOND_LIST: '/system/profession_second_list',
}

export async function professionList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function professionTopList() {
    return requestGet(api.TOP_LIST, {});
}

export async function professionSecondList(id) {
    let params = {id: id};
    return requestGet(api.SECOND_LIST, params);
}

export async function professionAdd(form) {
    return requestPost(api.ADD, form);
}

export async function professionUpdate(form) {
    return requestPost(api.UPDATE, form);
}

export async function professionDel(id) {
	let params = {id: id};
    return requestPost(api.DEL, params);
}

export async function workNameIsExist(account) {
    let params = {val: account};
    return requestGet(api.IS_EXIST_WORK_NAME, params);
}

